/**
 * Toast hook wrapper for sonner
 * Provides a consistent API for showing toast notifications
 */

import { toast as sonnerToast } from 'sonner';

interface ToastOptions {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success' | 'warning';
  duration?: number;
}

export function useToast() {
  const toast = (options: ToastOptions) => {
    const { title, description, variant = 'default', duration } = options;

    const message = title || description || '';
    const descriptionText = title && description ? description : undefined;

    switch (variant) {
      case 'destructive':
        return sonnerToast.error(message, {
          description: descriptionText,
          duration,
        });
      case 'success':
        return sonnerToast.success(message, {
          description: descriptionText,
          duration,
        });
      case 'warning':
        return sonnerToast.warning(message, {
          description: descriptionText,
          duration,
        });
      default:
        return sonnerToast(message, {
          description: descriptionText,
          duration,
        });
    }
  };

  return { toast };
}

export { sonnerToast as toast };
